module.exports = __webpack_public_path__ + "img/mb-pkg-bg.e7b17c83.png";